import { render } from "./viewInvestment.vue?vue&type=template&id=78b3ca6f&scoped=true"
import script from "./viewInvestment.vue?vue&type=script&lang=js"
export * from "./viewInvestment.vue?vue&type=script&lang=js"

import "./viewInvestment.vue?vue&type=style&index=0&id=78b3ca6f&scoped=true&lang=css"

import exportComponent from "E:\\workspace2017\\vue3.0\\premia-user-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78b3ca6f"]])

export default __exports__